import { Navigate, NavigateProps } from 'react-router-dom';
import { useLocale } from '@/contexts/LocaleContext';

interface LocaleNavigateProps extends Omit<NavigateProps, 'to'> {
  to: string;
}

/**
 * A locale-aware Navigate that automatically prepends the current locale prefix.
 */
const LocaleNavigate = ({ to, ...props }: LocaleNavigateProps) => {
  let localizedTo = to;

  try {
    const { getLocalizedPath } = useLocale();
    if (to.startsWith('/') && !to.match(/^\/[a-z]{2}-[A-Z]{2}(\/|$)/)) {
      localizedTo = getLocalizedPath(to);
    }
  } catch {
    // Outside LocaleProvider, use path as-is
  }

  return <Navigate to={localizedTo} {...props} />;
};

export default LocaleNavigate;
